import ResetPasswordModule from '@/modules/reset-password/ResetPasswordModule';

export default ResetPasswordModule;

